import parseISO from 'date-fns/parseISO';
import isPast from 'date-fns/isPast';
import type { Dividend } from '@benzinga/calendar-manager';

export type DividendStatus = 'paid' | 'declared' | 'estimated';

export const DIVIDEND_STATUS_LABELS: Record<DividendStatus, string> = {
  declared: 'Declared',
  estimated: 'Estimated',
  paid: 'Paid',
};

export const getDividendStatus = (
  dividend: Pick<Dividend, 'confirmed' | 'payable_date' | 'ex_dividend_date'>,
): DividendStatus => {
  const statusDate = dividend.payable_date || dividend.ex_dividend_date;
  if (statusDate && isPast(parseISO(statusDate))) {
    return 'paid';
  }

  if (dividend.confirmed === true) {
    return 'declared';
  }

  return 'estimated';
};
